import React, { Fragment } from 'react';
import * as R from 'ramda';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Popover from '@mui/material/Popover';
import Button from '@mui/material/Button';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Check from '@mui/icons-material/Check';

export var Field = function Field(_ref) {
  var _ref$spotlight = _ref.spotlight,
      spotlight = _ref$spotlight === undefined ? {} : _ref$spotlight,
      onChangeField = _ref.onChangeField,
      isRtl = _ref.isRtl,
      classes = _ref.classes;

  var _React$useState = React.useState(null),
      anchorEl = _React$useState[0],
      setAnchorEl = _React$useState[1];

  var handleClick = function handleClick(event) {
    setAnchorEl(event.currentTarget);
  };

  var handleClose = function handleClose() {
    setAnchorEl(null);
  };

  var open = Boolean(anchorEl);
  var id = open ? 'visions-spotlight-popover' : undefined;

  return React.createElement(
    Fragment,
    null,
    React.createElement(
      Button,
      { 'aria-describedby': id, onClick: handleClick },
      React.createElement(
        'div',
        { className: classes.buttonContainer },
        R.prop('searchLabel', spotlight),
        React.createElement(ArrowDropDownIcon, { fontSize: 'small' })
      )
    ),
    React.createElement(
      Popover,
      {
        id: id,
        open: open,
        anchorEl: anchorEl,
        onClose: handleClose,
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'center'
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'center'
        }
      },
      React.createElement(
        'div',
        { dir: isRtl ? 'rtl' : 'ltr', className: classes.popoverButton },
        R.pipe(R.values, R.map(function (field) {
          var _cx;

          return React.createElement(
            Button,
            {
              key: field.id,
              className: classes.buttonContainer,
              onClick: onChangeField(field),
              disabled: field.disabled
            },
            React.createElement(Check, {
              fontSize: 'small',
              className: cx((_cx = {}, _cx[classes.selected] = !R.prop('isSelected')(field), _cx))
            }),
            React.createElement(spotlight.FieldLabelRenderer, { id: field.id })
          );
        }))(R.prop('fields', spotlight))
      )
    )
  );
};

Field.propTypes = process.env.NODE_ENV !== "production" ? {
  classes: PropTypes.object,
  spotlight: PropTypes.shape({
    fields: PropTypes.shape({
      id: PropTypes.string,
      isSelected: PropTypes.bool,
      disabled: PropTypes.bool
    }),
    searchLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    FieldLabelRenderer: PropTypes.func
  }),
  onChangeField: PropTypes.func.isRequired,
  isRtl: PropTypes.bool
} : {};